import { RetrieveAuthorizationVerbiageResponseV1 } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsReviewPaymentAuthorizationVerbiageActions =
  createActionGroup({
    source: 'Hosted Payments Review Payment Authorization Verbiage',
    events: {
      'Bank Authorization Verbiage Retrieved': props<{
        payload: RetrieveAuthorizationVerbiageResponseV1;
      }>(),
    },
  });
